module.exports = __webpack_public_path__ + "static/media/add.2b51980a.svg";